<template lang="pug">
  .popup-message.js-popup-message
    .popup-message__layout(v-on:click="popupLocal('popupMessage', 'close')")
    .popup-message__content-wr
      .popup-message__content-layout
      .popup-message__close-wr(v-on:click="popupLocal('popupMessage', 'close')")
        SvgIcon(class='popup-message__close-ico' name="close" width="42" height="42")

      .popup-message__content
        .popup-message__message
          | Форма отправлена, мы с вами свяжемся

</template>

<script>
  import EventBus from '@/eventBus';

  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

  // @ is an alias to /src

  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';

  export default {
    name: 'PopupCall',

    mixins: [AjaxHelpersVue, PopupHelpersVue],

    components: {
      SvgIcon
    },

    data() {
      return {
        message: null
      }
    },

    created() {
      EventBus.$on('popupMessageDataLoaded', res => {
        if(this.checkProperty(res.message)) {
          this.message = res.message;
        }
      });
    },

    methods: {
      popupLocal(type, action) {
        this.popup(type, action);
      }
    }
  }
</script>
